<template>
  <div class="area">
    <h1>Información personal</h1>
    <hr />
    <div class="col-12">
      <label>Nombre: </label>
      <label>{{usuario.Nombre}}</label>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        usuario: this.props
      }
    },
    props: ['props']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Tablero/Usuario/InformacionPersonal.vue